import React from 'react';
import NewarkRichTextOutput from './NewarkRichTextOuput';
import BRSpan from '../../General/BRSpan';

export default props => {
  return (
    <div className="newark__welcome-message-container">
      <div className="newark__welcome-message-left">
        <img role="presentation" src={props.image} className="newark__welcome-message-image"/>
      </div>
      <div className="newark__welcome-message-right">
        <div className="newark__welcome-message-content">

          <h1 className="newark__welcome-message-heading-1">
            <BRSpan str={props.headline}/>

          </h1>
          <div className="newark__welcome-message-body">
            <NewarkRichTextOutput ops={props.bodyOps}/>
          </div>
        </div>
      </div>
    </div>
  );
};


// WEBPACK FOOTER //
// ./src/Components/Theme/Newark/NewarkWelcomeMessage.js